import {getColor} from "@/styles/ThemeConfig";
import PinDinnerIcon from '/public/images/pin_dinner.svg';
import PinCocktailIcon from '/public/images/pin_cocktail.svg';
import styled from "@emotion/styled";
import {Button} from "@/components/base/Buttons";
import {useEffect, useState} from "react";

const ItemsWrapper = styled.div`
    position: relative;
    margin-left: 10px;
    padding-bottom: 5px;
    border-left: 1px dashed #d6d6d6;
    
    margin-bottom: 40px;
`
const ListItem = styled.div`
    margin-top: 34px;
    position: relative;
    padding-left: 27px;
    
    :before{
        content: '';
        position: absolute;
        top: 0;
        left: -11px;
        width: 26px;
        height: 28px;
        background: url(${ ({isUpgrade}) => isUpgrade ?  PinCocktailIcon?.src : PinDinnerIcon?.src}) no-repeat;
    }
`

const ListItemUpgrade = styled.div`
    margin-top: 34px;
    position: relative;
    padding-left: 27px;
    font-size: 1.1em;
    
    :before{
        content: '';
        position: absolute;
        top: 0;
        left: -11px;
        width: 26px;
        height: 28px;
        background: url(${PinCocktailIcon?.src}) no-repeat;
    }
`

const UpgradeTourDescription = styled.p`
    text-transform: uppercase;
    a{
        color:${getColor('gold')};
        text-decoration: none;
    }
`

export default function TourWillDoSection({title,description,items,isUpgrade,upgradeTour, note, ...rest})
{
    {/*UpgradeTourDescription creates hydratation errors -> Ensures the content only renders on the client side */}
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);


    return <div className={'container'} {...rest}>
        {title && <h2 style={{
            color:getColor('gold'),
            fontSize:'24px',
            fontWeight:'bold',
            fontFamily:'Josefin Sans',
            textTransform:'uppercase',
        }}>{title}</h2>}

        {isMounted && <p dangerouslySetInnerHTML={{__html:description}}/>}


        <ItemsWrapper>
            {items?.map((item, index) => {
                return <ListItem key={index} isUpgrade={isUpgrade}>
                    {
                        item?.title && <p style={{
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            fontSize: '1.1em'
                        }}>{item?.title}</p>
                    }

                    {item?.description}
                </ListItem>
            })}
        </ItemsWrapper>

        {upgradeTour && <>
            {/*UpgradeTourDescription creates hydratation errors*/}
            {isMounted && <UpgradeTourDescription dangerouslySetInnerHTML={{__html:upgradeTour?.data?.info?.description}}/>}


            <ItemsWrapper>
                {upgradeTour?.data?.whatYouWillDo?.items?.map((item, index) => {
                    return <ListItemUpgrade key={index}>
                        {
                            !isUpgrade ?
                                item?.title
                                :
                                <>
                                    {
                                        item?.title && <p style={{
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            fontSize: '1.1em'
                                        }}>{item?.title}</p>
                                    }

                                    {item?.description}
                                </>
                        }

                    </ListItemUpgrade>
                })}
            </ItemsWrapper>

            <Button variant={'green'} href={upgradeTour?.slug}>ADD UPGRADED DRINKS PACKAGE</Button>
        </>}

        {
            note &&
            <p
                style={{
                    color: getColor('lightGreen'),
                    marginTop: '50px',
                    whiteSpace: 'pre-line' // Ensures line breaks are respected
                }}
                dangerouslySetInnerHTML={{ __html: note.replace(/\n/g, '<br>') }}
            />
        }

    </div>
}
